import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ThumbsUp from '@johnlewispartnership/wtr-ingredients/dist/Icon/ThumbsUp';
import ThumbsDown from '@johnlewispartnership/wtr-ingredients/dist/Icon/ThumbsDown';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import FeedbackSelector from '../../components/CustomerFeedback/FeedbackSelector';
import FeedbackButton from '../../components/CustomerFeedback/FeedbackButton';
import ThankYouMessage from '../../components/CustomerFeedback/ThankYouMessage';
import styles from './CustomerFeedback.module.scss';
const OPTIONS = [
    "Didn't answer my question",
    'It is too long',
    "Didn't go into enough detail",
    "Doesn't make sense",
    "Can't find the question",
];
class CustomerFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventName: 'was_this_helpful',
            customerFeedback: null,
        };
        this.feedbackSection = createRef();
    }
    scrollToFeedbacktop() {
        if (this.feedbackSection.current && this.feedbackSection.current.scrollIntoView) {
            this.feedbackSection.current.scrollIntoView({ behavior: 'smooth' });
        }
    }
    wasHelpful(value) {
        this.submitCustomerFeedback(value ? 'yes' : 'no');
        this.setState({ customerFeedback: value });
    }
    submitCustomerFeedback(value) {
        const { eventName } = this.state;
        const { submitCustomerFeedback } = this.props;
        submitCustomerFeedback({ eventName, value });
        this.scrollToFeedbacktop();
    }
    render() {
        const { customerFeedback } = this.state;
        const { breakpointClasses } = this.props;
        return (React.createElement("section", { className: classNames(breakpointClasses, styles.sectionWrapper), ref: this.feedbackSection }, customerFeedback === null ? (React.createElement("div", { "aria-controls": "helpfulInfo", className: styles.card },
            React.createElement(Typography, { element: "h2", styleAs: "sectionHeadingLight", noMargins: true }, "Was this page helpful?"),
            React.createElement("div", { className: styles.feedbackButtons },
                React.createElement("div", { className: styles.yesFeedbackContainer },
                    React.createElement(FeedbackButton, { icon: React.createElement(ThumbsUp, { className: styles.icon }), dataTest: "customer-feedback-yes", label: "Yes", onClick: () => this.wasHelpful(true) })),
                React.createElement("div", { className: styles.noFeedbackContainer },
                    React.createElement(FeedbackButton, { icon: React.createElement(ThumbsDown, { className: styles.icon }), dataTest: "customer-feedback-no", label: "No", onClick: () => this.wasHelpful(false) }))))) : (React.createElement("div", { role: "status", id: "helpfulInfo", "aria-live": "assertive", className: styles.card },
            customerFeedback === true && React.createElement(ThankYouMessage, null),
            customerFeedback === false && (React.createElement(FeedbackSelector, { onSubmit: feedback => this.submitCustomerFeedback(feedback), options: OPTIONS }))))));
    }
}
CustomerFeedback.displayName = 'CustomerFeedback';
CustomerFeedback.defaultProps = {
    breakpointClasses: undefined,
};
CustomerFeedback.propTypes = {
    breakpointClasses: PropTypes.arrayOf(PropTypes.string),
    submitCustomerFeedback: PropTypes.func.isRequired,
};
export default CustomerFeedback;
//# sourceMappingURL=CustomerFeedback.js.map